<div>
  <div class="chart-container" tooltipPosition="bottom" pTooltip="{{ videoTooltip }}" (click)="tutorialClick()">
    <div class="metric-widget-container">
      <div class="metric">{{metric}}
      </div>
      <div class="metric-name">{{metricName}}</div>
    </div>
  </div>
</div>